import { SET_IS_OPEN_MODAL } from '../actionTypes';
import { createAttachmentModalActions } from '../reducer';

export default (value) =>
    createAttachmentModalActions[SET_IS_OPEN_MODAL](value);
